// Shared media regular expressions and helpers
export const YOUTUBE_ID_REGEXP =
  /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
export const VIDEO_URL_REGEXP = /^https?:\/\/.*\/.*\.(mp4|webm|ogg)\??.*$/i

export function extractYouTubeId(url = '') {
  const match = url && url.match(YOUTUBE_ID_REGEXP)
  return match && match[1]?.length === 11 ? match[1] : null
}
